import { PORT_PLACE_LIST, PORT_PLACE_PAGINATION } from "./constant";
import { APICall } from "@/config/NetworkUtility";

export const getPortPlaceList = (payload) => {
  return (dispatch) => {
    const queryParams = new URLSearchParams({
      ...payload,
    }).toString();

    const url = `v1/MasterPort/GetPortPlacesList?${queryParams}`;
    return APICall("get", payload, url).then(
      (result) => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
          dispatch({
            type: PORT_PLACE_LIST,
            payload: result?.data || [],
          });
          dispatch({
            type: PORT_PLACE_PAGINATION,
            payload: result?.pagination || {},
          });
          return result?.data;
        } else {
          return Promise.reject();
        }
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  };
};

export const createPortPlace = (payload) => {
  const url = `v1/MasterPort/CreatePortPlaces`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else if(result?.statuscode === 404 ){
        return result;
      } else {
        throw new Error((result?.statuscode));
      }
    },
    (error) => {
      return error;
    },
  );
};

export const UpdatePortPlace = (payload) => {
  const url = `v1/MasterPort/UpdatePortPlaces`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else if(result?.statuscode === 404 ){
        return result;
      } else {
        throw new Error((result?.statuscode));
      }
    },
    (error) => {
      return error;
    },
  );
};

export const DeletePortPlace = (payload) => {
  const url = `v1/MasterPort/DeletePortPlaces`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else {
        return false;
      }
    },
    (error) => {
      return error;
    },
  );
};
